Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var _ref$tickContainerSiz = _ref.tickContainerSize,
    tickContainerSize = _ref$tickContainerSiz === void 0 ? 1.125 : _ref$tickContainerSiz;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    bp = _STYLES$useStyles.bp;
  var container = {
    backgroundColor: COLORS.whisper,
    borderRadius: (0, _styles.getREM)(0.75),
    paddingTop: (0, _styles.getREM)(0.5),
    paddingBottom: (0, _styles.getREM)(0.5),
    paddingLeft: (0, _styles.getREM)(0.75),
    paddingRight: (0, _styles.getREM)(0.75),
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  };
  var container_active = {
    backgroundColor: COLORS.pastelPink
  };
  var buttonContainer = {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };
  var buttonText = {
    width: '100%',
    height: '100%',
    borderRadius: (0, _styles.getREM)(0.75)
  };
  var tickContainer = {
    borderRadius: tickContainerSize,
    width: tickContainerSize,
    height: tickContainerSize,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.aubergine
  };
  var text = Object.assign({}, fontSemiBold, {
    fontSize: _styles.STYLES.fontSize.xs,
    lineHeight: _styles.STYLES.lineHeight.xs,
    color: COLORS.aubergine,
    marginLeft: (0, _styles.getREM)(0.375),
    marginRight: (0, _styles.getREM)(0.375)
  });
  if (bp.is([bp.tablet, bp.desktop])) {
    text.fontSize = _styles.STYLES.fontSize.s;
    text.lineHeight = _styles.STYLES.lineHeight.s;
  }
  var styles = _reactNative.StyleSheet.create({
    container: container,
    container_active: container_active,
    buttonContainer: buttonContainer,
    buttonText: buttonText,
    tickContainer: tickContainer,
    text: text
  });
  return {
    styles: styles
  };
};